import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./header.scss";
import { CapitalizeWords } from "../../helpers";

const titleMap = {
    "/master/product_category/add_product_category": "Add Product Category",
    "/master/product_category/edit_product_category": "Edit Product Category",

    "/master/product_list/add_product_list": "Add Product List",
    "/master/product_list/edit_product_list": "Edit Product List",
};

// 🔥 Mongo ObjectId detector
const isMongoId = (value) => /^[0-9a-fA-F]{24}$/.test(value);

// 🔥 Entity → Detail Title
const detailTitleByEntity = {
    administrator: "Administrator Detail",
    user: "User Detail",
    superadmin: "Administrator Detail",
};

function formatPathToTitle(path) {
    const segments = path.split("/").filter(Boolean);
    const lastSegment = segments[segments.length - 1];

    return lastSegment
        .replace(/_/g, " ")
        .replace(/\b\w/g, char => char.toUpperCase());
}

const Header = () => {
    const location = useLocation();
    const [pathName, setPathName] = useState("");
    const [breadCumb, setBreadCumb] = useState([]);

    useEffect(() => {
        const pathSegments = location.pathname.split("/").filter(Boolean);
        const bread = ["", ...pathSegments];

        const currentPath = `/${pathSegments.join("/")}`;
        const mappedTitle = titleMap[currentPath];

        if (pathSegments.length === 0) {
            setPathName("Dashboard");
            setBreadCumb(bread);
            return;
        }

        const lastSegment = pathSegments[pathSegments.length - 1];

        // 🔥 Cari entity SETELAH "master"
        const masterIndex = pathSegments.indexOf("master");
        const entity =
            masterIndex !== -1 ? pathSegments[masterIndex + 1] : pathSegments[0];

        // 🔥 Deteksi halaman DETAIL
        const isDetailPage =
            pathSegments.includes("detail") && isMongoId(lastSegment);

        // ===== HEADER TITLE =====
        if (mappedTitle) {
            setPathName(mappedTitle);
        } 
        else if (isDetailPage) {
            setPathName(detailTitleByEntity[entity] || "Detail");
        } 
        else {
            setPathName(formatPathToTitle(currentPath));
        }

        setBreadCumb(bread);
    }, [location]);

    return (
        <div className="header">
            <div className="title-header">
                {CapitalizeWords(pathName)}
            </div>

            <div className="breadcumb d-flex flex-row">
                {breadCumb.map((segment, index) => {
                    if (index === 0) return null;

                    const href = `/${breadCumb.slice(1, index + 1).join("/")}`;
                    const isLast = index === breadCumb.length - 1;

                    // ❌ Sembunyikan ID
                    if (isMongoId(segment)) return null;

                    const label =
                        segment === "detail"
                            ? "Detail"
                            : CapitalizeWords(segment.replace("_", " "));

                    return (
                        <div key={index}>
                            <span className={isLast ? "breadcumb-active" : ""}>
                                {isLast ? label : <Link to={href}>{label}</Link>}
                                {!isLast && <span className="mx-2"> / </span>}
                            </span>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default Header;
